<div class="frame">
  <video #videoPlayer class="capture video-js" crossorigin muted preload="auto"></video>
</div>
<div id="nb-global-spinner" class="spinner" [style.visibility]="loading ? 'visible' : 'hidden'">
  <div class="blob blob-0"></div>
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>
  <div class="blob blob-3"></div>
  <div class="blob blob-4"></div>
  <div class="blob blob-5"></div>
</div>
